var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddHexagon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    viewBox: "0 0 38 40",
    width: 38,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "translate(1 1.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 23.761v-9.524c0-3.204 1.704-6.166 4.472-7.778l9-5.238c2.798-1.628 6.256-1.628 9.054 0l9 5.238c2.77 1.612 4.474 4.574 4.474 7.778v9.524c0 3.204-1.704 6.166-4.472 7.778l-9 5.238c-2.798 1.628-6.256 1.628-9.054 0l-9-5.238c-2.77-1.612-4.474-4.574-4.474-7.778z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 14.999v8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 18.999h8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m-5-4h48v48h-48z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddHexagon);
export default __webpack_public_path__ + "static/media/add-hexagon.8b551ec34faf63cdb68e3d40c8a889e6.svg";
export { ForwardRef as ReactComponent };